






import { Component, Vue } from "vue-property-decorator";
import MainLayout from "@/pages/Main.vue";
import ErrorLayout from "@/pages/Error.vue";

@Component({
  components: {
    MainLayout,
    ErrorLayout,
  },
})
export default class App extends Vue {
  get layout(): string {
    const name: string = this.$route.name || "";
    return name.split(".")[0];
  }
}
